import React from 'react';
import { Link } from 'react-router-dom';

function EstatePlanning() {
  const donateItems = [
    "Residential property",
    "Vacant land",
    "Farms",
    "Apartment buildings",
    "Condos",
    "Commercial",
    "Industrial",
  ];

  const sectionTitle = (text) => (
    <h3 style={{ fontSize: "1rem", fontWeight: 700, color: "#c47a1e", marginBottom: "0.8rem" }}>
      {text}
    </h3>
  );

  const paragraph = (children, key) => (
    <p key={key} style={{ fontSize: "13.5px", lineHeight: "1.78", color: "#333", marginBottom: "0.9rem" }}>
      {children}
    </p>
  );

  return (
    <div style={{ fontFamily: "'Georgia','Times New Roman',serif", color: "#222", backgroundColor: "#fff" }}>
      <div style={{ maxWidth: "900px", margin: "0 auto", padding: "0 1.5rem 3.5rem" }}>

        {/* ── Back link ── */}
        <Link to="/" style={{ fontSize: "13px", color: "#c47a1e", margin: "1.5rem 0 0", display: "inline-block", textDecoration: "none", userSelect: "none" }}>
          ← Back to Home
        </Link>

        {/* ── Heading ── */}
        <h1 style={{ fontFamily: "'Dancing Script','Brush Script MT',cursive", fontSize: "2.4rem", color: "#c47a1e", margin: "1.2rem 0 0.15rem", fontWeight: 700 }}>
          Estate Planning / Giving
        </h1>
        <div style={{ display: "flex", gap: "4px", marginBottom: "2rem" }}>
          {[...Array(9)].map((_, i) => (
            <div key={i} style={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#c47a1e" }} />
          ))}
        </div>

        {/* ── Plan Today to Change Tomorrow + donate box ── */}
        <div style={{ display: "flex", gap: "1.8rem", alignItems: "flex-start", marginBottom: "1.5rem", flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: "260px" }}>
            {sectionTitle("Plan Today to Change Tomorrow")}
            {paragraph("You've worked hard, and God's been good to you. Diligently, you have built towards a vision of the future for your family and your financial life.")}
            {paragraph("Now, with a little planning today, you can make huge change for tomorrow for your family and for God's Kingdom by leaving a gift to Christ For India in your will.")}
            {paragraph("Leaving a plan for all your financial blessings can bring tremendous comfort and stability when you are called to your heavenly home. It also helps orient your loved ones on the things that matter most—at least the things that mattered to you the most.")}
          </div>

          <div style={{
            flex: "0 0 220px", minWidth: "200px", backgroundColor: "#e87b1e", color: "#fff",
            padding: "1.4rem 1.6rem", borderRadius: "2px",
          }}>
            <p style={{ fontSize: "13px", fontWeight: 700, marginBottom: "0.8rem" }}>
              You can donate:
            </p>
            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
              {donateItems.map((item, i) => (
                <li key={i} style={{ fontSize: "13px", lineHeight: "1.9" }}>
                  – {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* ── Continuation text ── */}
        {paragraph("The most important things in life cannot be counted in financial terms. When you make a charitable gift to CFI in your will, you are sharing with those you leave behind your passion for God's Kingdom in this world.")}
        {paragraph("From a tax planning perspective, leaving a bequest to a Christ For India can help keep you in firm control of your legacy. Depending on the size and structure of your estate, charitable contributions can significantly reduce estate taxes, ensuring that more of your hard-earned wealth is utilized to promote the growth of God's Kingdom rather than the expansion of human government.")}

        {/* ── How to Give a Charitable Bequest to CFI ── */}
        <div style={{ marginTop: "1.5rem" }}>
          {sectionTitle("How to Give a Charitable Bequest to CFI")}
          {paragraph("To make a charitable bequest, you typically specify in your will the amount of money, assets, or a percentage of your estate that you wish to give.")}
          {paragraph("It's important to consult with an attorney or legal advisor when creating or updating your will. And please let us know if you are considering (or have already) placing Christ For India in your will so that we can prepare to best utilize your gift for the work of the ministry.")}
        </div>

        {/* ── Asset-Based Giving ── */}
        <div style={{ marginTop: "1.5rem" }}>
          {sectionTitle("Asset-Based Giving: Generosity that Knows No Bounds")}
          {paragraph("Want to help even more people in India know the love of God through Jesus Christ? With CFI's charitable account, you can now make gifts of stocks and real estate!")}
          {paragraph("You may never have considered this, but there is immense potential lying within your assets not only for your financial future but also for the future of missions. Beyond their monetary value, items like real estate, businesses, or equity carry the promise of transformative change.")}
          {paragraph("By donating these assets to Christ For India, you are harnessing that potential for the Kingdom of God. You're turning a piece of property or a share in a business into a lifeline of salvation, hope, and education for those who need it most.")}
          {paragraph(<>So please call our Edward Jones representatives today at <strong>(972) 772-0407</strong> for more information on how you can empower the work of the Kingdom through your stocks, real estate, and other asset-based gifts.</>)}
        </div>

        {/* ── Contact row ── */}
        <div style={{
          display: "flex", justifyContent: "center", gap: "3.5rem",
          marginTop: "3rem", flexWrap: "wrap", textAlign: "center",
        }}>
          <div>
            <a
              href="https://outlook.office.com/mail/deeplink/compose?to=cfimin@christforindia.org"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                color: "inherit",
                cursor: "pointer",
                display: "inline-block",
              }}
              title="Click to open Outlook Web compose email"
            >
              <div
                style={{
                  fontSize: "2rem",
                  color: "#e87b1e",
                  marginBottom: "0.5rem",
                  transition: "transform 0.2s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              >
                📫
              </div>
              <p style={{ fontSize: "12.5px", color: "#333", margin: 0, fontWeight: "600" }}>
                cfimin@christforindia.org
              </p>
            </a>
          </div>

          <div>
            <div style={{ fontSize: "2rem", color: "#e87b1e", marginBottom: "0.5rem" }}>✉️</div>
            <p style={{ fontSize: "12.5px", color: "#333", margin: 0 }}>P.O. Box 271086</p>
            <p style={{ fontSize: "12.5px", color: "#333", margin: 0 }}>Dallas, TX 75 227</p>
          </div>

          <div>
            <div style={{ fontSize: "2rem", color: "#e87b1e", marginBottom: "0.5rem" }}>📞</div>
            <p style={{ fontSize: "12.5px", color: "#333", margin: 0 }}>+1 (800) 943-0380</p>
            <p style={{ fontSize: "12.5px", color: "#333", margin: 0 }}>+1 (972) 771-7221</p>
          </div>
        </div>

      </div>
    </div>
  );
}

export default EstatePlanning;
